export const getSectionTilesGridStyle = () => ({
  sectionTilesGridContainer: {
    '& .section-title': {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '24px',
      // color: palette.neutralPrimary,

      marginBottom: 12,
      marginLeft: 12,
    },
  },
});
